const useIsValidReport = (report) => {
  if (!report) {
    return false;
  }

  if (!report.name) {
    return false;
  }

  if (report.type === 'oneTime') {
    if (!report.periodStart || !report.periodEnd) {
      return false;
    }
  }

  if (report.type === 'periodic') {
    if (!report.schedule) {
      return false;
    }
  }

  if (!report.scope) {
    return false;
  }

  if (report.selection === 'specific') {
    if (!report.elements.length) {
      return false;
    }
  }

  if (!report.recipients.length) {
    return false;
  }

  return true;
};

export default useIsValidReport;
